export default "__VITE_ASSET__DAfeuLs$__"